// System settings store. GET is public (the signup screen needs the publicSignups
// gate + trial before auth); PATCH is System-only.
import { api } from '../api';

export const settingsStore = {
  async get() {
    const { settings } = await api.get('/api/settings');
    return settings;
  },
  async update(patch) {
    const { settings } = await api.patch('/api/settings', patch);
    return settings;
  },
};
